import HCY_FamerAndCattle, {
  ChessObj,
  ChessPointInfo,
  PointType,
} from "./HCY_FamerAndCattle";

const { ccclass, property } = cc._decorator;

@ccclass
export default class MovePoint extends cc.Component {
  @property({ displayName: "自身id" })
  private MyId: number = 0;
  public get ID() {
    return this.MyId;
  }

  @property({ type: MovePoint, displayName: "连通点" })
  private Connected: MovePoint[] = [];
  // LIFE-CYCLE CALLBACKS:
  @property({ type: cc.Enum(ChessObj), displayName: "所放物品" })
  private PutItem: ChessObj = ChessObj.None;

  @property({ type: cc.Enum(PointType), displayName: "点类型" })
  private PointType: PointType = PointType.Normal;

  private MyInfo: ChessPointInfo = null;

  private LevelBorad: HCY_FamerAndCattle = null;

  onLoad() {
    let allConnect: number[] = [];
    this.MyInfo = {
      id: this.MyId,
      connected: allConnect,
      put: this.PutItem,
      node: this.node,
      PointType: this.PointType,
    };
    this.LevelBorad = this.node.parent.parent.getComponent(HCY_FamerAndCattle);
    this.LevelBorad.PushChessInfo(this.MyInfo);
  }

  onEnable() {
    this.Connected.forEach((point) => {
      this.SetConnectId(point.ID);
      point.SetConnectId(this.ID); //相互之间连通
    });
    this.node.on(cc.Node.EventType.TOUCH_START, this.OnClickSelf, this);
  }

  OnClickSelf(e: cc.Event.EventTouch) {
    this.LevelBorad.MoveToClickPoint(this.MyInfo);
  }

  SetConnectId(id: number) {
    if (this.MyInfo.connected.indexOf(id) > -1) {
      //已存在的连通点无需加入其中
      return;
    }
    this.MyInfo.connected.push(id);
  }

  // update (dt) {}
}
